<!--<div class="modal fade modal-confirmation" id="downloadModal" tabindex="-1" aria-labelledby="downloadModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="downloadModalLabel">Download Auditbericht</h1>
                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
                    <img src="assets/icons/closeOutlined.svg" />
                </button>
            </div>
            <div class="modal-body">
                <div class="data-document d-flex">
                    <label class="right-line">{{ this.institutionName }}</label>
                    <label class="right-line">{{ this.wardName}}</label>
                    <label>{{ this.departmentName }}</label>
                </div>
                <div class="detail-document">
                    <label class="right-line">{{creationDate}}</label>
                    <label>{{creationHour}}</label>
                </div>
                <div class="format-document">
                    <div class="title-format">Format</div>
                    <div class="detail-format">
                        <img src="assets/icons/wordFormat.svg" />
                        <span>Word</span>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Abbrechen</button>
                <button type="button" class="btn btn-confirm" data-dismiss="modal" (click)="download()">Download</button>
            </div>
        </div>
    </div>
</div>-->

<div class="modal fade modal-confirmation" id="completeCheckModal" tabindex="-1"
    aria-labelledby="completeCheckModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title fs-5" id="completeCheckModalLabel">{{ 'CHECK.CONFIRM_END_PROCESS' | translate }}</h5>
                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
                    <img src="assets/icons/closeOutlined.svg" />
                </button>
            </div>

            <div class="modal-body"> {{ 'CHECK.CONFIRM_END_PROCESS_DELETE' | translate }} </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-cancel" data-dismiss="modal">{{ 'BUTTON.CANCEL' | translate }}</button>
                <button type="button" class="btn btn-confirm" data-dismiss="modal" (click)="saveChanges()">{{ 'CONFIGURE.ACCEPT' | translate }}</button>
            </div>
        </div>
    </div>